import Lista from './Lista';

export const CategoriaDeCurriculoLista = Lista;
